module.exports = __webpack_public_path__ + "static/media/processing-icon.d3cdb7ee.svg";